module.exports = __webpack_public_path__ + "static/media/bulldozer_indigo.df97aa3e.svg";